import React from 'react';
import { Actions } from '../../SnipingOpportunitiesCard/columns';
import { HotTokensRowInfo } from 'api/types/httpsTypes/contracts';

export const ActionsColumn = React.memo(
  ({ data }: { data: HotTokensRowInfo }) => {
    return (
      <Actions
        tokenAddress={data.tokenAddress}
        chain={data.chain}
        symbol={data.base}
        poolAddress={data.poolAddress}
      />
    );
  }
);
